export function initPricing() {
    const pricing = document.querySelector('.billing-input');
    if(!pricing) return;

    pricing.addEventListener('change', e=>{
        document.documentElement.classList.toggle('is-monthly', e.target.checked);
    });
}